import { render, staticRenderFns } from "./PromoOfferDialog.vue?vue&type=template&id=38f34c12&scoped=true"
import script from "./PromoOfferDialog.vue?vue&type=script&lang=js"
export * from "./PromoOfferDialog.vue?vue&type=script&lang=js"
import style0 from "./PromoOfferDialog.vue?vue&type=style&index=0&id=38f34c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f34c12",
  null
  
)

export default component.exports